export default "__VITE_ASSET__nYGaUXtB__"